import React from 'react';
import Culture from '../components/aboutUs/Culture';
// import Kampus from '../components/aboutUs/Kampus';
import KernelValues from '../components/aboutUs/KernelValues';
import OurCoreValues from '../components/aboutUs/OurCoreValues';
import Title from '../components/shared/Title';
import Metrics from '../components/aboutUs/Metrics';
import { MapTypes } from '../components/shared/constants/MapTypes';
import MapLocations from '../components/shared/MapLocations';
import TalkUsReduce from '../assets/imgs/bg-talk-us-reduce.png';

const AboutUsPage = () => {
  const mapType = MapTypes.FOOTPRINT;

  return (
    <>
      <div className="bg-custom md:px-52 py-20 px-10">
        <div className="3xl:max-w-[1500px] 3xl:inline-block">
          <h1 className="text-white-50 fk-about-title md:flex md: justify-center text-center font-bold text-5xl flex items-center">
            <Title text1="About" text2="Factor K" colorForText={2} isLight={true} />
          </h1>
          <div className="text-center text-white-50 text-xl">
            <p className="mb-5">
              We strive to be your nearshore software technology partner or choice. We will support your digital strategy and solve your software development needs by providing you
              with the best nearshore talent through staff augmentation, dedicated teams, and consulting. Our company is headquartered in San José, Costa Rica (GMT-6, Central Time
              Zone). Our staff is culturally aligned with U.S. business practices. We are committed to growing with you and offering the best customer experience while attracting
              and retaining the best technical talent.
            </p>
          </div>
        </div>
      </div>
      <MapLocations mapType={mapType} />
      <KernelValues />
      <OurCoreValues />
      <div
        className="w-full bg-cover bg-no-repeat md:px-32 py-10 px-4 text-xl"
        style={{ backgroundImage: `url(${TalkUsReduce})` }}
      >
        <div className="3xl:max-w-[1350px] 3xl:inline-block">
          <div className="grid md:grid-cols-2 gap-4 md:my-6 my-2">
            <div className="flex flex-col items-center text-center">
              <Title text1="Mission"  colorForText={1} />
              <p className="text-grey-700">
                Transforming our clients' technological challenges into opportunities through reliable, agile, and high-quality services
              </p>
            </div>
            <div className="flex flex-col items-center text-center">
              <Title text1="Vision" colorForText={1} />
              <p className="text-grey-700">
                Becoming a leader in nearshore services, recognized for our great talent, culture, customer support and excellence
              </p>
            </div>
          </div>
        </div>
      </div>
      <Culture />
      <Metrics />
    </>
  );
};

export default AboutUsPage;
